<template>
  <div>
    <div class="empty">
      <div class="empty-icon" v-if="icon">
        <component :is="icon" stroke-width="1" />
      </div>
      <p class="empty-title text-muted">{{ title }}</p>
      <p v-if="subtitle" class="empty-subtitle text-secondary">
        {{ subtitle }}
      </p>
      <div v-if="$slots.default" class="empty-action">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Component } from 'vue';

export interface Props {
  title: string;
  subtitle?: string;
  icon?: Component;
}

withDefaults(defineProps<Props>(), {
  subtitle: undefined,
  icon: undefined,
});
</script>
